import { render, staticRenderFns } from "./ClockTimeFourOutline.vue?vue&type=template&id=56b4e4e6"
import script from "./ClockTimeFourOutline.vue?vue&type=script&lang=js"
export * from "./ClockTimeFourOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports